import React, { useCallback, useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Link, useLocation } from "react-router-dom";
import { ErrorToast, SuccessToast } from "../../../../Utils/SweetAlert";
import { useQuery } from "@tanstack/react-query";
import ImageViewer from "react-simple-image-viewer";

import { MdOutlineCurrencyPound } from "react-icons/md";
import { GetSingleDiscover } from "../../../../Api/discover";
import BackButton from "../../../../Components/BackButton";

const DiscoverDetail = () => {
  const stateData = useLocation();
  const { id } = stateData?.state || "";
  const [data, setData] = useState(null);
  const [isDiscoverLoading, setIsDiscoverLoading] = useState(true);

  /**
   * Used to open image viewer
   */

  /**
   * Used to close image viewer
   */
  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  /**
   * Get guide product single record
   */

  const fetchDiscover = async () => {
    try {
      setIsDiscoverLoading(true);
      const response = await GetSingleDiscover({ Id: id });
      setData(response);
    } catch (error) {
      ErrorToast(error?.response?.data?.message || "Server Error.");
    } finally {
      setIsDiscoverLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchDiscover();
    }
  }, [id])

  return (
    <>
      <Helmet>
        <title>OVE | Admin Discover Detail</title>
      </Helmet>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-border">
                <div className="card-body">
                  <div className="page-header d-block">
                    <div className="row">
                      <div className="col">
                        <h3 className="page-title">Discover Detail</h3>
                      </div>
                      <div className="col-auto pt-4">
                        <BackButton to="/admin/discover-listing" />
                      </div>
                    </div>
                    <div className="row ">
                      {!isDiscoverLoading && data !== undefined && (
                        <span className="modal-title-value">
                          {data?.data?.title}
                        </span>
                      )}
                    </div>
                  </div>
                  {!isDiscoverLoading && data !== undefined && (
                    <>
                      <div className="row">
                        <div className="col-6">
                          <label className="d-block modal-label">Icon</label>
                          <div>
                            {data?.data?.iconUrl ? (
                              <img
                                src={data?.data?.iconUrl}
                                alt={data?.data?.iconUrl}
                                height={170}
                                width={244}
                                className="discover-img-detail"
                              />
                            ) : (
                              "-"
                            )}
                          </div>
                        </div>
                        <div className="col-6">
                          <label className="d-block modal-label">Image</label>
                          <div>
                            {data?.data?.imageUrl ? (
                              <img
                                src={data?.data?.imageUrl}
                                alt={data?.data?.imageUrl}
                                height={170}
                                width={244}
                                className="discover-img-detail"
                              />
                            ) : (
                              "-"
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="row mt-4">
                        <div className="col-6">
                          <label className="d-block modal-label">Name</label>
                          <p className="d-block modal-value detail-backg">
                            {data?.data?.name || "-"}
                          </p>
                        </div>
                        <div className="col-6">
                          <label className="d-block modal-label">Type</label>
                          <p className="d-block modal-value detail-backg">
                            {data?.data?.type || "-"}
                          </p>
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="col-12">
                          <label className="d-block modal-label">
                            Item Description
                          </label>
                          <p className="d-block modal-value detail-backg">
                            {data?.data?.itemDescription || "-"}
                          </p>
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div className="col-12">
                          <label className="d-block modal-label">
                            {" "}
                            Description
                          </label>
                          {data?.data?.description.map((value, index) => (
                            <div key={index}>
                              <div className="d-block modal-value detail-backg mb-3">
                                {value.description}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                      <div>
                        {data?.data?.discoverQuestions?.length > 0 && (
                          <p className="heading-discover">Questions</p>
                        )}
                      </div>

                      {data?.data?.discoverQuestions?.length > 0 && (
                        <div>
                          {data?.data?.discoverQuestions?.map((item, index) => (
                            <div key={item._id} className="section-border">
                              <div>
                                <div className="row">
                                  <div className="col-md-8">
                                    <label className="d-block modal-label">
                                      {`Question ${index + 1}`}
                                    </label>
                                    <div className="d-block modal-value detail-des-question-backg">
                                      {item?.question || "-"}
                                    </div>
                                  </div>
                                  <div className="col-md-4 d-block">
                                    <label className="d-block modal-label">
                                      Image
                                    </label>
                                    <div>
                                      {item?.imageUrl ? (
                                        <img
                                          src={item?.imageUrl}
                                          alt={item?.imageUrl}
                                          height={140}
                                          width={244}
                                          className="discover-img-detail"
                                        />
                                      ) : (
                                        "-"
                                      )}
                                    </div>
                                  </div>
                                </div>

                                <div className="col-sm-12 table-width mt-4">
                                  <div className="cards-table product-variantion card-table">
                                    <div className="card-body">
                                      <div className="table-responsive dis-ans-table custom-pagination">
                                        <table className="table datatable table-manager">
                                          <thead className="thead-light">
                                            <tr>
                                              <th>Answer</th>
                                              <th>Correct</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {item?.answers?.map(
                                              (answer, ansIndex) => (
                                                <tr
                                                  key={`${item._id}-answer-${ansIndex}`}
                                                >
                                                  <td>
                                                    <div>
                                                      {answer?.answer || "-"}
                                                    </div>
                                                  </td>
                                                  <td>
                                                    {answer?.correct == true
                                                      ? "True"
                                                      : "False" || "-"}
                                                  </td>
                                                </tr>
                                              )
                                            )}
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DiscoverDetail;
